import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import { styleMap as i } from '../../../../node_modules/lit-html/directives/style-map.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { unsafeHTML as o$1 } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import { getCookie } from '../../utilities/backend-helpers/index.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import { clearPendingTabReturn, updateTabHash, getAndClearPendingTabReturn, storePendingTabReturn } from '../../utilities/tabs-auth/index.js';
import { TabsOrientation } from './enums.js';
import img from '../../../../assets/images/arrow-tab-left.svg.js';
import img$1 from '../../../../assets/images/arrow-tab-right.svg.js';

const TAB_ITEM_SELECTOR = 'tab-item-updated';
class TabsUpdated extends s {
    constructor() {
        super(...arguments);
        this.tabsInitialized = false;
        this.selectedTabId = '';
        this.orientation = TabsOrientation.HORIZONTAL;
        this.rtl = false;
        this.visibleScroll = false;
        this.previousTabLabel = 'Previous tab';
        this.nextTabLabel = 'Next tab';
        this.pointerShift = '0px';
        this.pointerWidth = '0px';
        this.gatedContent = null;
        this.hasOverflow = false;
        this.pendingReturnTabId = '';
        this.hashChangeHandler = this.handleHashChange.bind(this);
        this.pageShowHandler = (e) => {
            if (e.persisted) {
                clearPendingTabReturn(this.pendingTabReturnKey);
            }
        };
        this.resizeObserver = null;
    }
    createRenderRoot() {
        return this;
    }
    get tabs() {
        return Array.from(this.querySelectorAll(TAB_ITEM_SELECTOR));
    }
    get pendingTabReturnKey() {
        return `tabs-updated-pending-tab-return-${this.id || 'default'}`;
    }
    get isVertical() {
        return this.orientation === TabsOrientation.VERTICAL;
    }
    get currentTabIndex() {
        if (!this.tabs || this.tabs.length === 0)
            return -1;
        return this.tabs.findIndex(t => t.selected);
    }
    get isFirstTab() {
        return this.currentTabIndex === 0;
    }
    get isLastTab() {
        return this.currentTabIndex === this.tabs.length - 1;
    }
    get showLeftArrow() {
        const rtlMode = this.rtl || isRTL();
        const shouldShow = rtlMode ? !this.isLastTab : !this.isFirstTab;
        return this.hasOverflow && shouldShow && this.tabs && this.tabs.length > 1;
    }
    get showRightArrow() {
        const rtlMode = this.rtl || isRTL();
        const shouldShow = rtlMode ? !this.isFirstTab : !this.isLastTab;
        return this.hasOverflow && shouldShow && this.tabs && this.tabs.length > 1;
    }
    setSelectedToPreviousTab(currentTab) {
        if (!this.tabs || this.tabs.length === 0)
            return;
        const currentIndex = this.tabs.indexOf(currentTab);
        if (currentIndex === -1)
            return;
        const index = currentIndex === 0 ? this.tabs.length - 1 : currentIndex - 1;
        this.handleTabClick(this.tabs[index]);
    }
    setSelectedToNextTab(currentTab) {
        if (!this.tabs || this.tabs.length === 0)
            return;
        const currentIndex = this.tabs.indexOf(currentTab);
        if (currentIndex === -1)
            return;
        const index = currentIndex === this.tabs.length - 1 ? 0 : currentIndex + 1;
        this.handleTabClick(this.tabs[index]);
    }
    handleHorizontalNavigation(ev, tab) {
        const rtlMode = this.rtl || isRTL();
        switch (ev.key) {
            case 'ArrowLeft':
                rtlMode ? this.setSelectedToNextTab(tab) : this.setSelectedToPreviousTab(tab);
                return true;
            case 'ArrowRight':
                rtlMode ? this.setSelectedToPreviousTab(tab) : this.setSelectedToNextTab(tab);
                return true;
            case 'Home':
                if (this.tabs && this.tabs.length > 0)
                    this.handleTabClick(this.tabs[0]);
                return true;
            case 'End':
                if (this.tabs && this.tabs.length > 0)
                    this.handleTabClick(this.tabs[this.tabs.length - 1]);
                return true;
            default:
                return false;
        }
    }
    handleVerticalNavigation(ev, tab) {
        switch (ev.key) {
            case 'ArrowUp':
                this.setSelectedToPreviousTab(tab);
                return true;
            case 'ArrowDown':
                this.setSelectedToNextTab(tab);
                return true;
            case 'Home':
                if (this.tabs && this.tabs.length > 0)
                    this.handleTabClick(this.tabs[0]);
                return true;
            case 'End':
                if (this.tabs && this.tabs.length > 0)
                    this.handleTabClick(this.tabs[this.tabs.length - 1]);
                return true;
            default:
                return false;
        }
    }
    handleTabKeyDown(ev, tab) {
        const handled = this.isVertical
            ? this.handleVerticalNavigation(ev, tab)
            : this.handleHorizontalNavigation(ev, tab);
        if (handled) {
            ev.stopPropagation();
            ev.preventDefault();
        }
    }
    setActiveTab(selectedTab, setFocus) {
        const shouldFocus = typeof setFocus === 'boolean' ? setFocus : true;
        if (!selectedTab)
            return;
        if (selectedTab.withRestrictedContent && selectedTab.tabId) {
            const restrictedModal = document.querySelector(`restricted-content[tabid="${selectedTab.tabId}"]`);
            if (restrictedModal) {
                const cookieName = restrictedModal.cookieName || 'AllowRestrictedContent';
                const cookieValue = getCookie(cookieName);
                if (cookieValue !== '1') {
                    this.handleRestrictedContent(selectedTab);
                    return;
                }
            }
        }
        for (let i = 0; i < this.tabs.length; i += 1) {
            const tab = this.tabs[i];
            tab.selected = selectedTab === tab;
        }
        this.selectedTabId = selectedTab.originalId;
        if (shouldFocus && selectedTab.originalId) {
            updateTabHash(selectedTab.originalId);
        }
        this.requestUpdate();
        if (shouldFocus) {
            requestAnimationFrame(() => {
                const { buttonId } = selectedTab;
                const escapedId = CSS.escape(buttonId);
                const btn = this.querySelector(`#${escapedId}`);
                if (btn) {
                    btn.focus();
                    btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
                }
            });
        }
    }
    initializeTabs() {
        const hash = globalThis.location.hash.slice(1);
        const hashTab = hash ? this.tabs.find(t => t.originalId === hash) : null;
        const isReturningFromAuth = !!this.pendingReturnTabId;
        const pendingTab = this.pendingReturnTabId
            ? this.tabs.find(t => t.originalId === this.pendingReturnTabId)
            : null;
        this.pendingReturnTabId = '';
        const hasSelectedTab = this.tabs.some(t => t.selected);
        if (!hasSelectedTab) {
            const tabToSelect = isReturningFromAuth
                ? (pendingTab || hashTab || this.tabs[0])
                : (hashTab || this.tabs[0]);
            if (tabToSelect) {
                if (!isReturningFromAuth && tabToSelect.redirectUrl) {
                    this.handleTabClick(tabToSelect);
                }
                else {
                    this.setActiveTab(tabToSelect, !!(hashTab || pendingTab));
                }
            }
        }
        else {
            const selected = this.tabs.find(t => t.selected);
            if (selected)
                this.selectedTabId = selected.originalId;
        }
    }
    async navigateToHashTab() {
        const hash = globalThis.location.hash.slice(1);
        if (!hash || !this.tabs || this.tabs.length === 0)
            return;
        const tab = this.tabs.find(t => t.originalId === hash);
        if (!tab)
            return;
        if (tab.redirectUrl) {
            this.handleTabClick(tab);
            return;
        }
        this.setActiveTab(tab, false);
    }
    handleHashChange() {
        this.navigateToHashTab();
    }
    checkOverflow() {
        const navList = this.querySelector('.nav-list');
        if (navList) {
            this.hasOverflow = navList.scrollWidth > navList.clientWidth;
        }
    }
    firstUpdated() {
        const pending = getAndClearPendingTabReturn(this.pendingTabReturnKey);
        if (pending === null || pending === void 0 ? void 0 : pending.tabId) {
            this.pendingReturnTabId = pending.tabId;
        }
        requestAnimationFrame(() => {
            this.moveTabsToContent();
            if (this.tabs && this.tabs.length > 0 && !this.tabsInitialized) {
                this.initializeTabs();
                this.tabsInitialized = true;
            }
            this.checkOverflow();
            document.fonts.ready.then(() => {
                requestAnimationFrame(() => {
                    const activeButton = this.querySelector('.tabs-nav button.selected');
                    if (activeButton)
                        this.updatePointerPosition(activeButton);
                });
            });
        });
        globalThis.addEventListener('hashchange', this.hashChangeHandler);
        globalThis.addEventListener('pageshow', this.pageShowHandler);
        this.resizeObserver = new ResizeObserver(() => {
            this.checkOverflow();
            const activeButton = this.querySelector('.tabs-nav button.selected');
            if (activeButton)
                this.updatePointerPosition(activeButton);
        });
        const navList = this.querySelector('.nav-list');
        if (navList)
            this.resizeObserver.observe(navList);
    }
    moveTabsToContent() {
        const contentDiv = this.querySelector('.content');
        if (!contentDiv)
            return;
        const tabItems = Array.from(this.querySelectorAll(TAB_ITEM_SELECTOR));
        tabItems.forEach(tab => {
            if (tab.parentElement !== contentDiv)
                contentDiv.appendChild(tab);
        });
    }
    disconnectedCallback() {
        var _a;
        super.disconnectedCallback();
        globalThis.removeEventListener('hashchange', this.hashChangeHandler);
        globalThis.removeEventListener('pageshow', this.pageShowHandler);
        (_a = this.resizeObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
    }
    updatePointerPosition(activeButton) {
        this.pointerWidth = `${activeButton.clientWidth}px`;
        if (this.isVertical) {
            this.pointerShift = `${activeButton.offsetTop + activeButton.clientHeight - 7}px`;
        }
        else if (this.rtl || isRTL()) {
            const navList = this.querySelector('.nav-list');
            if (navList) {
                const navWidth = navList.clientWidth;
                this.pointerShift = `${navWidth - activeButton.offsetLeft - activeButton.clientWidth}px`;
            }
        }
        else {
            this.pointerShift = `${activeButton.offsetLeft}px`;
        }
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        requestAnimationFrame(() => {
            this.moveTabsToContent();
        });
        if (!this.tabsInitialized && this.tabs && this.tabs.length > 0) {
            this.initializeTabs();
            this.tabsInitialized = true;
        }
        if (changedProperties.has('selectedTabId')) {
            requestAnimationFrame(() => {
                const activeButton = this.querySelector('.tabs-nav button.selected');
                if (activeButton)
                    this.updatePointerPosition(activeButton);
            });
        }
    }
    checkCookieAndActivateTab(tab, modal) {
        const cookieName = modal.cookieName || 'AllowRestrictedContent';
        const cookieValue = getCookie(cookieName);
        if (cookieValue === '1') {
            this.setActiveTab(tab, false);
            return true;
        }
        return false;
    }
    setupModalAcceptanceListener(tab, modal) {
        const handleAcceptance = (e) => {
            if (e.detail.tabId === tab.tabId) {
                this.setActiveTab(tab, false);
                modal.removeEventListener('restricted-content-accepted', handleAcceptance);
            }
        };
        modal.addEventListener('restricted-content-accepted', handleAcceptance);
        modal.showContent();
    }
    handleRestrictedContent(tab) {
        if (!tab.withRestrictedContent)
            return;
        this.gatedContent = tab;
        let restrictedContentModal = document.querySelector(`restricted-content[tabid="${tab.tabId}"]`);
        if (!restrictedContentModal) {
            restrictedContentModal = document.querySelector('restricted-content');
        }
        if (!restrictedContentModal)
            return;
        if (this.checkCookieAndActivateTab(tab, restrictedContentModal))
            return;
        if (typeof restrictedContentModal.showContent === 'function') {
            this.setupModalAcceptanceListener(tab, restrictedContentModal);
        }
    }
    handleTabClick(tab) {
        if (tab.redirectUrl) {
            storePendingTabReturn(tab.originalId, this.pendingTabReturnKey);
            globalThis.location.href = tab.redirectUrl;
            return;
        }
        if (tab.withRestrictedContent && tab.tabId) {
            this.handleRestrictedContent(tab);
            return;
        }
        this.setActiveTab(tab);
    }
    handleLeftArrowClick(e) {
        e.preventDefault();
        e.stopPropagation();
        const currentTab = this.tabs.find(t => t.selected);
        if (currentTab) {
            const rtlMode = this.rtl || isRTL();
            rtlMode ? this.setSelectedToNextTab(currentTab) : this.setSelectedToPreviousTab(currentTab);
        }
    }
    handleRightArrowClick(e) {
        e.preventDefault();
        e.stopPropagation();
        const currentTab = this.tabs.find(t => t.selected);
        if (currentTab) {
            const rtlMode = this.rtl || isRTL();
            rtlMode ? this.setSelectedToPreviousTab(currentTab) : this.setSelectedToNextTab(currentTab);
        }
    }
    renderTab(tab) {
        const isSelected = !!tab.selected;
        const tabindexValue = isSelected ? 0 : -1;
        return $ `<button id="${tab.buttonId}" role="tab" class="${o({ selected: isSelected })}" aria-selected="${isSelected ? 'true' : 'false'}" aria-controls="${tab.panelId}" tabindex="${tabindexValue}" @click="${() => this.handleTabClick(tab)}" @keydown="${(e) => this.handleTabKeyDown(e, tab)}" name="${tab.name}"><span class="tab-text">${o$1(tab.name)}</span></button>`;
    }
    renderNavigationArrow(direction, handler) {
        const ariaLabel = direction === 'left' ? this.previousTabLabel : this.nextTabLabel;
        const arrowSrc = direction === 'left' ? img : img$1;
        return $ `<button class="nav-arrow nav-arrow-${direction}" @click="${handler}" aria-label="${ariaLabel}" type="button"><img src="${arrowSrc}" alt="" aria-hidden="true"></button>`;
    }
    render() {
        const rtl = this.rtl || isRTL();
        const navClassMap = {
            'tabs-nav': true,
            [`tabs-${this.orientation}`]: true,
            'visible-scroll': this.visibleScroll,
            rtl,
        };
        const wrapperClassMap = {
            'tabs-navigation-wrapper': true,
            'has-overflow': this.hasOverflow,
        };
        const pointerStyleMap = this.isVertical
            ? i({ top: this.pointerShift, width: this.pointerWidth })
            : i(Object.assign(Object.assign({}, (rtl ? { right: this.pointerShift } : { left: this.pointerShift })), { width: this.pointerWidth }));
        return $ `<div class="${o(wrapperClassMap)}">${this.showLeftArrow ? this.renderNavigationArrow('left', this.handleLeftArrowClick) : ''}<div class="${o(navClassMap)}" role="tablist" aria-orientation="${this.isVertical ? 'vertical' : 'horizontal'}"><div class="nav-list">${this.tabs.map(tab => this.renderTab(tab))}<div class="pointer" style="${pointerStyleMap}"></div></div></div>${this.showRightArrow ? this.renderNavigationArrow('right', this.handleRightArrowClick) : ''}</div><div class="content"></div>`;
    }
}
__decorate([
    t()
], TabsUpdated.prototype, "tabsInitialized", void 0);
__decorate([
    t()
], TabsUpdated.prototype, "selectedTabId", void 0);
__decorate([
    e({ type: String })
], TabsUpdated.prototype, "orientation", void 0);
__decorate([
    e({ type: Boolean })
], TabsUpdated.prototype, "rtl", void 0);
__decorate([
    e({ type: Boolean })
], TabsUpdated.prototype, "visibleScroll", void 0);
__decorate([
    e({ type: String })
], TabsUpdated.prototype, "previousTabLabel", void 0);
__decorate([
    e({ type: String })
], TabsUpdated.prototype, "nextTabLabel", void 0);
__decorate([
    t()
], TabsUpdated.prototype, "pointerShift", void 0);
__decorate([
    t()
], TabsUpdated.prototype, "pointerWidth", void 0);
__decorate([
    t()
], TabsUpdated.prototype, "gatedContent", void 0);
__decorate([
    t()
], TabsUpdated.prototype, "hasOverflow", void 0);
customElements.define('tabs-container-updated', TabsUpdated);

export { TabsUpdated };
